/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { eventService } from '../../../services/event.service'
import './style.scss'
import dino from '../../../assets/footer/trex.svg'

export const EventPayment = () => {
  let { idEvento } = useParams()
  idEvento = idEvento.replace(/-/g, ' ')
  const [event, setEvent] = useState({})
  useEffect(() => {
    const getEvents = async () => {
      try {
        const dbEvent = await eventService.getOneEvent(idEvento)
        setEvent(dbEvent)
        console.log(dbEvent)
      } catch (error) {
        console.log(error.response.status)
        setEvent(null)
      }
    }
    const updateEvents = () => {
      event.boletos?.map(boleto => {
        boleto.precio = parseFloat(boleto.precio)
        return boleto
      })
    }
    getEvents()
    updateEvents()
  }, [])
  if (event === null) {
    return <Navigate to="/recurso-no-encontrado" />
  }
  return (
    <>
      <div>
        <section className="jarallax black-mode pt-2 pt-lg-3 pb-lg-5" data-jarallax data-speed="0.4">
          <span className="position-absolute top-0 start-0 w-100 h-100 black-mode" />
          <img className="jarallax-img"/>
          <div className="container position-relative zindex-5 pb-5">
            <div className="row p-4 ml-4">
                <h2> Pago </h2>
                <div className="col-sm">
                    <div className="row">
                        <div className="card-body p-4">
                            <div className="d-flex text-black">
                                <div className="flex-shrink-0">
                                    <img src={event.eventData?.foto_portada}
                                        alt="Generic placeholder image" className="img-fluid size"/>
                                </div>
                                <div className="flex-grow-1 ms-3 mt-4">
                                    <h5 className="mb-1">{event.eventData?.nombre}</h5>
                                    <div className="d-flex justify-content-start rounded-3 mb-2">
                                        <div>
                                            <p className="small text-muted mb-1"><b className="wheat"> vie, 11 de noviembre </b></p>
                                            <p className="small text-muted mb-1"><b className="wheat"> {event.eventData?.ubicacion}</b></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-4">
                        <button className='precio'>
                            <span className='wht'><b>Admisión General:   1 x 500 MXN</b></span>
                        </button>
                    </div>
                    <div className="row mb-4">
                        <button className='precio'>
                            <span className='wht'><b>Total: 500 MXN</b></span>
                        </button>
                    </div>
                    <div className="row">
                        <div className="col-3">
                            <img src={dino} width={70} className="ml-rarr" alt="RAARR" />
                        </div>
                        <div className="col-9">
                            <p><b className="wht">Comprando esta entrada, abrirás una cuenta y aceptarás nuestras <span className='wheat'>Condiciones de Uso</span> generales,
                            la <span className='wheat'>Política de Privacidad</span> y las <span className='wheat'>Condiciones de Compra</span> de entradas.
                            Procesamos tus datos personales de acuerdo con nuestra Política de Privacidad.</b>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-sm p-4 m-4">
                    <div className="card ml">
                        <div className="card-body">
                        <div className="card mb-3">
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item">
                                  <div className="row">
                                    <div className="col-4">
                                        <b className='blck'>Nombre</b>
                                    </div>
                                    <div className="col-8">
                                        <input type="text" className="form-control no-input" placeholder="Tu nombre"/>
                                    </div>
                                  </div>
                                </li>
                                <li className="list-group-item">
                                  <div className="row">
                                    <div className="col-4">
                                        <b className='blck'>Apellido</b>
                                    </div>
                                    <div className="col-8">
                                        <input type="text" className="form-control no-input" placeholder="Tu apellido"/>
                                    </div>
                                  </div>
                                </li>
                                <li className="list-group-item">
                                  <div className="row">
                                    <div className="col-4">
                                        <b className='blck'>Correo</b>
                                    </div>
                                    <div className="col-8">
                                        <input type="text" className="form-control no-input" placeholder="ejemplo@gmail.com"/>
                                    </div>
                                  </div>
                                </li>
                                <li className="list-group-item">
                                  <div className="row">
                                    <div className="col-4">
                                        <b className='blck'>Celular</b>
                                    </div>
                                    <div className="col-8">
                                        <input type="text" className="form-control no-input" placeholder="(442)-4700-582"/>
                                    </div>
                                  </div>
                                </li>
                            </ul>
                        </div>
                        <span className="px-4"><b className='blck'>No pierdas de vista los eventos de tu ciudad</b></span>
                        <div className="card mb-4 mt-3">
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item blck">
                                    <input type="checkbox" className="custom-control-input"/>
                                    <span className="ml">Correos electrónicos de RAARR</span>
                                </li>
                                <li className="list-group-item blck">
                                    <input type="checkbox" className="custom-control-input"/>
                                    <span className="ml">Correos electrónicos del organizador</span>
                                </li>
                            </ul>
                        </div>
                        <button className="btn btn-primary">
                            Continuar
                        </button>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}
